import { useTimeoutFn } from './useTimeoutFn.js';
import { useUpdate } from './useUpdate.js';
export const useTimeoutReady = (duration) => {
    const update = useUpdate();
    return useTimeoutFn(update, duration);
};
//# sourceMappingURL=useTimeoutReady.js.map